export enum LoginStateEnum {
  login = 'LOGIN',
  confirmationEmail = 'CONFIRMATION-EMAIL',
  twoFactorEmail = 'TWO-FACTOR-EMAIL',
  twoFactorGoogle = 'TWO-FACTOR-GOOGLE',
  twoFactorTrezor = 'TWO-FACTOR-TREZOR',
}
